import { render, staticRenderFns } from "./VoucherTag.vue?vue&type=template&id=72e22b8b&"
import script from "./VoucherTag.vue?vue&type=script&lang=js&"
export * from "./VoucherTag.vue?vue&type=script&lang=js&"
import style0 from "./VoucherTag.vue?vue&type=style&index=0&id=72e22b8b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports